// async function fetchGraphQL(text: any, variables?: any) {
//   const response = await fetch("http://127.0.0.1:4000/graphql", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       Accept: "application/json",
//     },
//     body: JSON.stringify({
//       query: text,
//       variables,
//     }),
//   });
//
//   // Get the response as JSON
//   return await response.json();
// }

import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client'

const NODE_ENV = import.meta.env.MODE || 'development'
const ROUTER_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000'

let graphQLEndpoint
switch (NODE_ENV) {
  case 'development':
    graphQLEndpoint = `/graphql`
    break
  case 'production':
    graphQLEndpoint = `${ROUTER_URL}/graphql`
    break
  case 'test':
  case 'e2e':
    graphQLEndpoint = 'http://localhost:4001/graphql'
    break
}

const link = createHttpLink({
  uri: graphQLEndpoint,
  credentials: 'include',
})

const client = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      Telemetry: {
        keyFields: [],
      },
      FacetInfoQuery: {
        keyFields: ['count', 'attribute'],
      },
      WaffleQuery: {
        keyFields: ['attribute', 'percentage'],
      },
    },
  }),
  link,
  connectToDevTools: NODE_ENV === 'development',
})

const mockedClient = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      Telemetry: {
        keyFields: [],
      },
      FacetInfoQuery: {
        keyFields: ['count', 'attribute'],
      },
      WaffleQuery: {
        keyFields: ['attribute', 'percentage'],
      },
    },
  }),
  link: createHttpLink({
    uri: 'http://localhost:4001/graphql',
    credentials: 'include',
  }),
  connectToDevTools: NODE_ENV === 'development',
})

export { client, mockedClient }
